import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignupService } from 'src/app/services/signup.service';

@Component({
  selector: 'dialog-print-invoice-label-dialog',
  templateUrl: 'print-invoice-label-dialog.html',
  styleUrls: ['print-invoice-label-dialog.css'],
})
export class PrintInVoiceAndLabelDialog implements OnDestroy, OnInit {
  shipmentData: any = {};
  userId: string = '';
  showInvoice: boolean = false;

  constructor(
    private signUpService: SignupService,
    public dialogRef: MatDialogRef<PrintInVoiceAndLabelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit(): void {
    this.shipmentData = this.data;

    this.userId = this.shipmentData.b2b_user_id;
    if(this.userId === '66b5f93192539c6048a62356' || this.userId === '676b353892539c44f3fc22bd'){
      this.showInvoice = true;
    } else{
      this.showInvoice = false;
    }
  }
  close(): void {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.shipmentData = {};
  }
  printLabel(label) {
    window.open(label, '_blank', 'noopener');
  }

  printInvoice() {
    var label = window.open(
      '/api/shipment/b2b/invoice/shippn/' + this.shipmentData.awb_no,
      '_blank',
      'noopener'
    );
    if(label){
      label.focus();
      label.print();
    }
    
  }
}
